import { render } from "./VendorCard.vue?vue&type=template&id=75b9355a"
import script from "./VendorCard.vue?vue&type=script&lang=js"
export * from "./VendorCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__